import React, { useContext } from "react";
import { ThemeContext } from "../App";

export default function footer({ isLoading, networkErr, baseFont }) {
  const currentTheme = process.env.REACT_APP_THEME;
  const themeConfig = useContext(ThemeContext);

  return (
    <footer
      className={`base-font ${themeConfig.footerBgColor} ${
        isLoading || networkErr
          ? "absolute bottom-0 sm:relative md:absolute md:bottom-0 w-full"
          : ""
      }`}
      style={baseFont}
    >
      <div
        className={`flex flex-col xl:inline-block w-full h-auto text-center text-sm py-10 ${themeConfig.footerBgColor} ${themeConfig.footerTextColor}`}
      >
        {currentTheme === "homelink" ? (
          <div className="bg-[#265CA4] w-full max-w-[1184px] mx-auto h-1 mt-4 mb-10"></div>
        ) : (
          ""
        )}
        <img
          src={themeConfig.footerLogo}
          alt="footer logo"
          className="w-footer-logo mx-auto"
        />
        <p
          className="max-w-140 mt-10 lg:mt-5 xl:max-w-none sm:px-0 xl:inline-block mx-auto"
          dangerouslySetInnerHTML={{ __html: themeConfig.copyrightText }}
        ></p>
      </div>
    </footer>
  );
}
